import React, { useRef, useState } from "react";
import { Button, Form, message, Modal, Upload } from "antd";
import { useAssetsEntryDetailsModel } from "./assetsEntryDetailsModel";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText } from "@/utils/utils"
import { assetsEntryService, IAssetsDetail } from "../../assetsEntryService";
import useGlobalModel from "@/model/globalModel";
import { debounce } from "lodash";
import { useDictModel } from '@/views/base/dict/dictModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { warehouseService } from "@/views/base/warehouseManage/warehouseService";
import { UploadOutlined, PlusOutlined, PlusSquareTwoTone } from "@ant-design/icons";
import FontIcon from "@/components/YhIcon";
import { UploadChangeParam } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";
import { fileDownload } from "@/utils/exportFile";
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from "@/utils/constants";
import { Image, Tooltip } from 'antd';
// 引入新增的货位添加组件
import { AddShelfModal } from "./AddShelfModal";

export function AddAssetsDrawer({ mode }) {
    const { user: { userName } } = useGlobalModel();
    const { getSelectedDictOne, getTreeSelectOne, getTreeNodeName } = useDictModel()
    const { addGoodsModal: visible, setAddGoodsModal, transformsToSDcGoods } = useAssetsEntryDetailsModel();
    const formRef = useRef<IYhFormRef>();
    const { warehouseList, setLoadingInfo, shopAndOrg } = useGlobalModel()

    // 新增状态管理：控制货位添加弹窗
    const [addShelfVisible, setAddShelfVisible] = useState<boolean>(false);
    const onCancel = () => {
        setAddGoodsModal(false);
    }

    //实时详情列表货位数据
    const [shelfAllList, setShelfAllList] = useState<any>([]);

    const changeWarehouseCode = async (value, options) => {
        let newRecords: any = []
        let params = {
            pageSize: 99999,
            pageNum: 1,
            ...shopAndOrg,
            warehouseId: options.id as string,
            warehouseCode: options.code,
            enable: "1"
        }
        const { retData: shelfAll } = await warehouseService.shelfAllPage(params)
        newRecords = shelfAll.map((item) => {
            return { ...item, label: item.code as string, value: item.code }
        })
        setShelfAllList(newRecords);
        formRef.current?.validateFields()
    }

    // 打开新增货位弹窗
    const handleOpenAddShelf = async () => {
        setAddShelfVisible(true);
    }

    // 新增货位成功后的回调
    const handleShelfAdded = (newShelf) => {
        // 将新货位添加到货位列表中
        setShelfAllList([...shelfAllList, newShelf]);
        // 自动选中新添加的货位
        formRef.current?.setFieldsValue({
            shelfCode: newShelf.value
        });
    }

    const normFile = (e: UploadChangeParam) => {
        if (e?.file.status === 'done') {
            if (e?.file.response.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e.file.response.retData,
                }
                e.fileList = [data]
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(async res => {
            let data = {
                ...res,
                branch: 'assets',
                warehouseName: res.warehouseCode ? warehouseList.find(item => item.value == res.warehouseCode)?.label : '',
                typeName: getTreeNodeName(res.typeCode) ?? '',
                unitName: res.unitCode ? getSelectedDictOne(DictCodeEnmu.ASSETS_UNIT).find(item => item.value == res.unitCode)?.label : '',
                // createUser: userName
            }
            const { fileList = [] } = res
            if (fileList.length > 0) {
                const file = fileList[0]
                if (!file?.uid) {
                    return message.error('文件信息有误，请重新上传文件')
                }
                data.md5 = file?.uid
                data.fileName = file?.name
            } else {
                data.md5 = ''
                data.fileName = ''
            }
            data.fileList = null
            let { retData, retCode } = await assetsEntryService.insertAssets((data as IAssetsDetail))
            if (retCode == '200') {
                let newData = retData.map((item) => {
                    return { ...data, code: item.code, barCode: item.barCode, id: item.id, num: 1, md5: data.md5, fileName: data.fileName }
                })
                transformsToSDcGoods(newData, mode)
                onCancel()
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "物资编码",
                fieldName: "code",
                span: 24,
                disable: true,
                placeholder: '自动生成'
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "条形码",
                fieldName: "barCode",
                placeholder: '自动生成',
                disable: true,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "物资名称",
                fieldName: "name",
                rules: [{ required: true, message: "请输入物资名称" }],
                span: 24,
            },
            {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: '物资类型',
                fieldName: 'typeCode',
                treeData: getTreeSelectOne(DictCodeEnmu.ASSETS_TYPE, true),
                rules: [{ required: true, message: "请选择物资类型" }],
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "规格型号",
                fieldName: "model",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "单价",
                fieldName: "purchasePrice",
                span: 24,
                rules: [{ required: true, pattern: /^[+-]?\d*\.?\d*$/, message: '请输入正确格式单价' }],
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '单位',
                fieldName: 'unitCode',
                options: getSelectedDictOne(DictCodeEnmu.ASSETS_UNIT),
                span: 24,
                showSearch: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购数量",
                fieldName: "num",
                span: 24,
                rules: [{ required: true, message: "请输入采购数量" }]
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '仓库',
                fieldName: 'warehouseCode',
                options: warehouseList,
                span: 24,
                onSelectChange: changeWarehouseCode,
                showSearch: true,
                rules: [{ required: true, message: "请选择仓库" }],
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span>
                    <PlusSquareTwoTone
                        twoToneColor="#1890ff"
                        style={{ cursor: 'pointer', margin: '0 5px' }}
                        onClick={() => {
                            if (!formRef.current?.getFieldsValue().warehouseCode) {
                                message.error("请选择仓库")
                            } else {
                                handleOpenAddShelf()
                            }
                        }}
                    />货位</span>,
                fieldName: 'shelfCode',
                options: shelfAllList,
                span: 24,
                showSearch: true,
                rules: [{ required: true, message: "请选择货位" }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '品牌',
                fieldName: 'brandName',
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '仓库名称',
                fieldName: 'warehouseName',
                span: 24,
                hidden: true
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '附件',
                fieldName: 'inMd5',
                colClassName: 'ant-col-h-auto',
                span: 24,
                formItem: (
                    <Form.Item name="fileList" label="附件" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 6 }}>
                        <Upload
                            onPreview={onPreview}
                            name="file"
                            disabled={mode == 'look'}
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture"
                            beforeUpload={(file) => {
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                }
                                return isLt20M
                            }}
                            iconRender={(file) => {
                                return (
                                    <FontIcon
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                        style={{ fontSize: '24px' }}
                                        type="icon-tupian"
                                    />
                                )
                            }}
                        >
                            <Button icon={<UploadOutlined />}>选择文件上传</Button>
                        </Upload>
                    </Form.Item>
                ),
            },
        ]
    };



    return (
        <>
            <YHDrawer
                {...{
                    title: "物品新增",
                    visible,
                    onCancel,
                    okText: "保存",
                    onOk: debounce(() => { onSubmit() }, 900)
                }}
            >
                <YhForm {...formConfig} />
            </YHDrawer>

            {/* 新增货位弹窗 */}
            <AddShelfModal
                visible={addShelfVisible}
                warehouseCode={formRef.current?.getFieldsValue().warehouseCode}
                onCancel={() => setAddShelfVisible(false)}
                onSuccess={handleShelfAdded}
            />
        </>
    )
}
